import { render, staticRenderFns } from "./dieboard-table.component.vue?vue&type=template&id=06e8b380&"
import script from "./dieboard-table.component.ts?vue&type=script&lang=ts&"
export * from "./dieboard-table.component.ts?vue&type=script&lang=ts&"
import style0 from "./dieboard-table.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
